let variantId = "";
$(document).on("click", ".product-color", function(){
    let color = $(this).find('span').text();
    $("#ProductSelect-product-template option").each(function(){
      if($(this).text().trim().indexOf(color) != -1){
        variantId = $(this).val();
      }
    })
    if($("#storeDispnible").attr("data-has-only-default-variant")){
      storeAvailability(variantId);
    }
}) 

if($("#storeDispnible").attr("data-has-only-default-variant")){
      storeAvailability($("#ProductSelect-product-template").val());
}

function storeAvailability(variantId){
  console.log(variantId);
  $("#shopify-section-store-availability").remove();
  fetch(window.Shopify.routes.root + "variants/"+variantId+"/?section_id=store-availability")
  .then(response => response.text())
  .then(text => {
      let ciudades = [];
      let tiendas = [];
      const container = document.querySelector('[data-store-availability-container]');
      const pickupAvailabilityHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section');
         
         $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
          	if(!ciudades.includes("Bogotá") && $(this).html().includes("Bogotá")){
                ciudades.push("Bogotá");
                $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                  if(!tiendas.includes(tiendas[i]) && $(this).html().includes("Bogotá")){
                    tiendas.push({tienda: "Bogotá", content: $(this).parent().html()});
                  }
                })
            }else if(!ciudades.includes("Medellín") && $(this).html().includes("Medellín")){
              ciudades.push("Medellín")
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                
                if($(this).html().includes("ANT")){
              		tiendas.push({tienda: "Medellín", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Pereira") && $(this).html().includes("Pereira")){
              ciudades.push("Pereira");
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                if(!tiendas.includes(tiendas[i]) && $(this).html().includes("Pereira")){
              		tiendas.push({tienda: "Pereira", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Barranquilla") && $(this).html().includes("Barranquilla")){
              console.log("aqui en barranquilla")
              ciudades.push("Barranquilla");
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                if(!tiendas.includes(tiendas[i]) && $(this).html().includes("Barranquilla")){
              		tiendas.push({tienda: "Barranquilla", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Cali") && $(this).html().includes("Cali")){
              ciudades.push("Cali");
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                if(!tiendas.includes(tiendas[i]) && $(this).html().includes("Cali")){
                  tiendas.push({tienda: "Cali", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Bucaramanga") && $(this).html().includes("Bucaramanga")){
              ciudades.push("Bucaramanga");
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                if(!tiendas.includes(tiendas[i]) && $(this).html().includes("Bucaramanga")){
                  tiendas.push({tienda: "Bucaramanga", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Cartagena") && $(this).html().includes("Cartagena")){
              ciudades.push("Cartagena");
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                if(!tiendas.includes(tiendas[i]) && $(this).html().includes("Cartagena")){
                  tiendas.push({tienda: "Cartagena", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Medellín") && $(this).html().includes("Sabaneta")){
              ciudades.push("Medellín")
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                
                if($(this).html().includes("ANT")){
              		tiendas.push({tienda: "Medellín", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("Santa Marta") && $(this).html().includes("Santa Marta")){
              ciudades.push("Santa Marta")
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                
                if($(this).html().includes("Santa Marta")){
              		tiendas.push({tienda: "Santa Marta", content: $(this).parent().html()});
                }
              })
            }else if(!ciudades.includes("San Andrés") && $(this).html().includes("San Andrés")){
              ciudades.push("San Andrés")
              $(pickupAvailabilityHTML).find('.store-availability-list__address').each(function(i){
                
                if($(this).html().includes("San Andrés")){
              		tiendas.push({tienda: "San Andrés", content: $(this).parent().html()});
                }
              })
            }
          })
          container.appendChild(pickupAvailabilityHTML);
          updateProductCiudades(ciudades, tiendas);
  })
  .catch(e => {
      console.error(e);
  });  
}

function updateProductCiudades(ciudades, tiendas){
      for(var i = 0; i < ciudades.length; i++){
        let ciudad = ciudades[i].replace(/ /gm, "");
        $(".container-ciudades").append("<div class='item-list-tiendas'><span>"+ciudades[i]+"</span><div class='container-tiendas-product container-tiendas-product-"+ciudad+"'></div></div>");
        for(var j = 0; j < tiendas.length; j++){
          if(tiendas[j].tienda == ciudades[i]){
          	$(".container-tiendas-product-"+ciudad).append(tiendas[j].content);
          }
        }
      }
      $(".container-ciudades .item-list-tiendas").click(function(){
        if($(this).find('.container-tiendas-product').is(":visible")){
            $('.container-tiendas-product').attr("style", "display: none;");
        	$(this).find('.container-tiendas-product').attr("style", "display: none;")
        }else{
            $('.container-tiendas-product').attr("style", "display: none;");
          	$(this).find('.container-tiendas-product').attr("style", "display: block; animation: zoomAnimation2 2s")
        }
        
      })
}

$(document).on("click", ".store-availability-information", function(){
  if($("#StoreAvailabilityModal").is(":visible")){
    $("#StoreAvailabilityModal").attr("style", "display: none");  
  }else{
    $("#StoreAvailabilityModal").attr("style", "display: flex");
    $("#imageProduct").attr('src', $("#storeDispnible").attr("data-product-image"));
  }
})

$(document).on("click", "#closeModalStoreAvailability", function(){
   $("#StoreAvailabilityModal").attr("style", "display: none");  
});

$("#StoreAvailabilityModal").click(function() {
   $(this).attr("style", "display: none");
});

$(document).on("click", ".content-store-availability", function(event){
    event.stopPropagation();
});

$(document).on("click", '#closeModalStoreAvailability', function(event){
    event.stopPropagation();
});

$(document).on("click", "#add-cart-store-avaible", function(){
    addProductStoreAvailability($(this).attr("data-id-product-variant"));
});

function addProductStoreAvailability (idVariant){
    console.log(idVariant)
    let formData = {
      'items': [{
      	'id': parseInt(idVariant),
      	'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
    })
    .then(response => {
       $(this).text("Agregado!").css("background","black");
       location.href = "/cart";
       
	})
    .catch((error) => {
       console.error('Error:', error);
    });
};
